export enum EphemeralDebugTarget {
    OctopusServer = "OctopusServer",
    ConnectionRelay = "ConnectionRelay"
}

export const ephemeralDebugTargetDescriptions: Record<EphemeralDebugTarget, string> = {
    [EphemeralDebugTarget.OctopusServer]: "Octopus Server",
    [EphemeralDebugTarget.ConnectionRelay]: "Connection Relay"
};
